import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  List,
  IconButton,
  Chip,
  Autocomplete,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MicIcon from "@mui/icons-material/Mic";
import StopIcon from "@mui/icons-material/Stop";

import { setLoading } from "../../redux/Slice/loaderSlice";
import { getQuote } from "../../redux/Slice/quoteSlice";
import { useDispatch, useSelector } from "react-redux";
import { authHeader } from "../../Api/authHeader";
import { ImageIcon } from "lucide-react";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Chatresponse from "../../pages/chat/Chatresponse";

const API_URL = process.env.REACT_APP_API_URL;

const ChatWithAllTempates = () => {
  const dispatch = useDispatch();

  const [messages, setMessages] = useState([
    {
      sender: "bot",
      options:true,
      text: JSON.stringify([
        {
          openAIResponse: { bot: "Hello! How can I assist you today?" },
        },
      ]),
    },
  ]);
  const [availableTags] = useState(["Recommended Products", "Lead"]);
  const [selectedTags, setSelectedTags] = useState("");
  const [input, setInput] = useState("");
  const [isStreaming, setIsStreaming] = useState(false);
  const [files, setFiles] = useState([]);
  const [recording, setRecording] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [ShowTemplates,setShowTemplates]= useState(false)
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [ask,setAsk]=useState(false)


  const { quotes } = useSelector((state) => state.quote);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  useEffect(() => {
    const fetchQuote = async () => {
      dispatch(setLoading(true));
      dispatch(getQuote());
      dispatch(setLoading(false));
    };
    fetchQuote();
  }, [dispatch]);

  const handleFileChange = (event) => {
    setFiles((prev) => [...prev, ...event.target.files]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCardSelect = (item) => {
    if (item.bot) return
      setSelectedItems((prev) => {
        const exists = prev.some(
          (i) => JSON.stringify(i) === JSON.stringify(item)
        );
        if (exists) {
          return prev.filter((i) => JSON.stringify(i) !== JSON.stringify(item));
        }
        return [...prev, item];
      });
  };
  const handleTagSelect = (tag) => {
    setSelectedTags((prev) => (prev === tag ? "" : tag));
  };

  const handleSendMessage = async (id,tag) => {
    const userMessage = {
      sender: "user",
      text: input,
      files: files.map((file) => ({
        name: file.name,
        type: file.type.split("/")[0], // 'image' or 'audio'
      })),
    };

    setMessages((prev) => [...prev, userMessage]);
    setInput("");
      setIsStreaming(true);
      setShowTemplates(false)

    try {
      const formData = new FormData();
      formData.append("quote_id", id);
      formData.append("tag", ask ? "Recommended Products" : "");
      formData.append(
        "prompt",
        `${
          selectedItems.length > 0 ? JSON.stringify(selectedItems) : ""
        }${input}`
      );

      files.forEach((file) => {
        formData.append(file.name.split(".")[0], file);
      });
      setFiles([]);

      const response = await fetch(`${API_URL}/api/chat`, {
        method: "POST",
        body: formData,
        headers: authHeader(),
      });

      const data = await response.json();

      let botMessage = { sender: "bot", text: JSON.stringify(data.data) };
      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      console.error("Error fetching response:", error);
    } finally {
      setSelectedItems([]);
      setIsStreaming(false);
        setFiles([]);
        setSelectedTemplate(null)
         setAsk(false);
    }
  };

  const startRecording = () => {
    // Request specific microphone permissions with optimized audio settings
    navigator.mediaDevices
      .getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: false,
        },
      })
      .then((stream) => {
        mediaRecorderRef.current = new MediaRecorder(stream, {
          mimeType: "audio/webm;codecs=opus",
          audioBitsPerSecond: 128000,
        });

        audioChunksRef.current = [];

        mediaRecorderRef.current.ondataavailable = (event) => {
          if (event.data.size > 0) {
            audioChunksRef.current.push(event.data);
          }
        };

        mediaRecorderRef.current.onstop = () => {
          const audioBlob = new Blob(audioChunksRef.current, {
            type: "audio/webm;codecs=opus",
          });

          // Create unique filename with timestamp
          const audioFile = new File(
            [audioBlob],
            `voice_message_${Date.now()}.webm`,
            { type: "audio/webm;codecs=opus" }
          );

          setFiles((prev) => [...prev, audioFile]);
          stream.getTracks().forEach((track) => track.stop()); // Clean up tracks
        };

        mediaRecorderRef.current.start();
        setRecording(true);
      })
      .catch((error) => {
        console.error("Microphone access error:", error);
        alert("Please enable microphone access in your browser settings!");
      });
  };

  const stopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "90vh",
        padding: 2,
      }}>
      <Typography variant="h4" gutterBottom>
        Chat
      </Typography>

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          marginBottom: 2,
          padding: 1,
          border: "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}>
        <List>
          {messages.map((message, index) => (
            <Chatresponse
              key={index}
              index={index}
              message={message}
              handleCardSelect={handleCardSelect}
              selectedItems={selectedItems}
              selectedTags={selectedTags}
              handleTagSelect={handleTagSelect}
              availableTags={availableTags}
            />
          ))}
        </List>
      </Box>

      {/* Display Uploaded Files */}
      {files.length > 0 && (
        <Box sx={{ marginBottom: 2 }}>
          <List>
            {files.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  gutterBottom>
                  Attachments:
                </Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {files.map((file, index) => (
                    <Chip
                      key={index}
                      icon={
                        file.type.startsWith("image/") ? (
                          <ImageIcon fontSize="small" />
                        ) : file.type.startsWith("audio/") ? (
                          <AudiotrackIcon fontSize="small" />
                        ) : (
                          <InsertDriveFileIcon fontSize="small" />
                        )
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            maxWidth: 120,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}>
                          {file.name}
                        </Typography>
                      }
                      onDelete={() => handleRemoveFile(index)}
                      onClick={() => {
                        if (file.type.startsWith("image/")) {
                          window.open(URL.createObjectURL(file), "_blank");
                        }
                      }}
                      sx={{
                        "& .MuiChip-deleteIcon": {
                          color: "inherit",
                          "&:hover": {
                            color: "error.main",
                          },
                        },
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
          </List>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 1,
          position: "relative",
        }}>
        <TextField
          variant="outlined"
          fullWidth
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type a message..."
          sx={{ marginRight: 1, width: "700px" }}
          disabled={isStreaming}
        />

        <Button component="label" variant="outlined" disabled={isStreaming}>
          <input type="file" hidden multiple onChange={handleFileChange} />
          <AttachFileIcon />
        </Button>

        <IconButton
          onClick={recording ? stopRecording : startRecording}
          disabled={isStreaming}>
          {recording ? <StopIcon color="error" /> : <MicIcon />}
        </IconButton>

        <Button
          variant="outlined"
          onClick={() => setShowTemplates(true)}
          startIcon={<SendIcon />}
          disabled={!input.trim() && files.length === 0}>
          {isStreaming ? "Thinking..." : "Send"}
        </Button>
        <Button
                  onClick={() => {
                      setShowTemplates(true);
                      setAsk(true)
                  }}
                  disabled={!input.trim()}
          variant="outlined"
          sx={{
            borderRadius: "50px",
            p: "0",
          }}>
          Ask
        </Button>
        {ShowTemplates ? (
          <Autocomplete
            disablePortal
            freeSolo
            disableClearable
            disableCloseOnSelect
            options={quotes}
            getOptionLabel={(option) => option.templateName}
            value={selectedTemplate}
            onChange={(event, newValue) => {
              console.log("newValue:", newValue);
              setSelectedTemplate(newValue);
              handleSendMessage(newValue._id);
            }}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            renderInput={(params) => (
              <TextField
                {...params}
                id="search"
                placeholder="Type Search ..."
                variant="outlined"
                sx={{ width: "150px", bgcolor: "white" }}
              />
            )}
            sx={{ position: "absolute", right: "20%", bottom: "60px" }}
          />
        ) : null}
      </Box>
    </Box>
  );
};

export default ChatWithAllTempates;
